module.exports = __webpack_public_path__ + "static/media/010.cca41b9f.jpg";